
import {whenReady} from "../general/Util";

const downloadBlob = ( blob, name = 'download.pdf' ) => {
	const linkEl = document.createElement( 'a' );
	linkEl.href = window.URL.createObjectURL( blob );
	linkEl.download = name;
	setTimeout( () => linkEl.click(), 500 );
	return true;
}

const downloadInvoice = ( orderNumber ) => {

	return fetch( "/index.php?cl=kastneraccount_mini_account&fnc=getWebserviceInvoiceReturnLabel&orderNumber=" + orderNumber + "&type=invoice", {
		method: 'POST'
	} )
		.then( res => res.blob() )
		.then( blob => {
			if ( blob.size === 0 ) {
				return Promise.reject();
			}

			return downloadBlob( blob, "Invoice-" + orderNumber + ".pdf" );
		} )
		.catch( err => {
			if ( err ) {
				console.error( err );
			}
			EN_KO.functions.open_popup( '#popup_noinvoiceavailable' );
			return false;
		} );
};

const downloadReturnLabel = ( orderNumber ) => {

	return fetch( "/index.php?cl=kastneraccount_mini_account&fnc=getWebserviceInvoiceReturnLabel&orderNumber=" + orderNumber + "&type=returnlabel", {
		method: 'POST'
	} )
		.then( res => res.blob() )
		.then( blob => {
			if ( blob.size === 0 ) {
				return Promise.reject();
			}

			return downloadBlob( blob, "ReturnLabel-" + orderNumber + ".pdf" );
		} )
		.catch( err => {
			if ( err ) {
				console.error( err );
			}
			EN_KO.functions.open_popup( '#popup_noreturnlabelavailable' );
			return false;
		} );
};

const openParcelTracking = ( orderNumber, method ) => {

	return fetch( "/index.php?cl=kastneraccount_mini_account&fnc=getWebserviceParcelTracking", {
		method: 'POST',
		body: new URLSearchParams( { orderNumber, method } )
	} )
		.then( res => res.text() )
		.then( data => {
			if ( ! data ) {
				return Promise.reject();
			}
			window.open( data, "_blank" );
			return true;
		} )
		.catch( ( err ) => {
			if ( err ) {
				console.error( err );
			}
			alert( "Keine Tracking-Nummer" )
			return false;
		} )
};


class MiniAccount {
	static downloadInvoice = ( orderNumber ) => downloadInvoice( orderNumber );
	static downloadReturnLabel = ( orderNumber ) => downloadReturnLabel( orderNumber );
	static openParcelTracking = ( orderNumber, method  ) => openParcelTracking( orderNumber, method );
};

whenReady.then( () => {
	const orderInputEl = document.getElementById( 'orderNumber' );
	const orderNumber = orderInputEl?.value;
	if ( ! orderNumber ) {
		return;
	}

	const invoiceDownloadEl = document.getElementById( 'invoice' );
	if ( invoiceDownloadEl ) {
		invoiceDownloadEl.addEventListener( 'click', ( ev ) => {
			ev.preventDefault();
			MiniAccount.downloadInvoice( orderNumber );
		} );
	}

	const retoureDownloadEl = document.getElementById( 'returnlabel' );
	if ( retoureDownloadEl ) {
		retoureDownloadEl.addEventListener( 'click', ( ev ) => {
			ev.preventDefault();
			MiniAccount.downloadReturnLabel( orderNumber );
		} );
	}

	const trackingButtonEl = document.getElementById( 'tracking-site' );
	if ( trackingButtonEl ) {
		const methodEl = document.getElementById( 'shipping-method' );
		trackingButtonEl.addEventListener( 'click', ( ev ) => {
			ev.preventDefault();
			MiniAccount.openParcelTracking( orderNumber, methodEl?.value || 'oxidstandard' );
		} );
	}
} );


export{
	MiniAccount as default,
	downloadInvoice,
	downloadReturnLabel,
	openParcelTracking
};
